var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": "Account verification | MyWhoosh - Your Indoor Cycling Solution"
    }
  }), _vm._m(0), _c('section', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col-md-6 mx-auto"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('h3', [_vm._v("Verify Account")]), _c('span', [_vm._v("Verify your account by entering OTP sent to your email address")]), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.verificationHandler();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.otp,
      expression: "form.otp"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.errors && _vm.errors.otp
    },
    attrs: {
      "type": "number",
      "id": "exampleInputEmail1",
      "placeholder": "Enter your OTP",
      "autocomplete": "chrome-off"
    },
    domProps: {
      "value": _vm.form.otp
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "otp", $event.target.value);
      }
    }
  }), _vm.errors && _vm.errors.otp ? _c('div', {
    staticClass: "invalid-feedback"
  }, [_vm._v(_vm._s(_vm.errors.otp))]) : _vm._e()]), _c('button', {
    staticClass: "btn-universal",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Verify Account")]), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Back to Login")]), _c('br'), _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Create New Account?")])], 1)])])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "overlay"
  }), _c('div', {
    staticClass: "sreachBar"
  }, [_c('h1', [_vm._v("Profile")])])])]);
}]

export { render, staticRenderFns }